import { render, staticRenderFns } from "./DkColorThumb.vue?vue&type=template&id=7edefe9d&"
import script from "./DkColorThumb.vue?vue&type=script&lang=js&"
export * from "./DkColorThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports